import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
// import NewsfeedNotification from './newsfeed';
import ConnectionNotification from './connections';
import MessagingNotification from './messaging';
import { ToolbarSeparator } from 'material-ui/Toolbar';

import R from 'ramda';
import {
  // getNotifications as getNotificationsAction,
  updateProps as updatePropsAction,
  markAsRead as markAsReadAction,
} from '../../../stores/notification/actions';

const propTypes = {
  // getNotifications: PropTypes.func,
  companyType: PropTypes.string,
  unreadCount: PropTypes.number,
  unseenCount: PropTypes.number,
  list: PropTypes.array,
  updateProps: PropTypes.func,
  markAsRead: PropTypes.func,
  connectionsStats: PropTypes.object,
  messaging: PropTypes.object,
  allApps: PropTypes.array,
};

class NotificationContainer extends React.Component {
  // componentWillMount() {
  //   this.props.getNotifications();
  // }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return (
      !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) ||
      !R.equals(this.state, nextState)
    );
  }

  render() {
    const { allApps } = this.props;
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ToolbarSeparator style={{ marginLeft: '20px' }} />
        { allApps.indexOf('s&m') > -1 && <ConnectionNotification /> }
        <MessagingNotification />
        {/* { allApps.indexOf('s&m') > -1 && <NewsfeedNotification /> } */}
        <ToolbarSeparator style={{ marginLeft: '8px' }} />
      </div>
    );
  }
}

const mapStateToProps = ({ notification, user }) => ({
  ...notification.toJS(),
  companyType: user.getIn(['user', 'type']),
  allApps: user.get('allApps'),
});

const mapDispatchToProps = dispatch => ({
  // getNotifications: (...args) => dispatch(getNotificationsAction(...args)),
  updateProps: (...args) => dispatch(updatePropsAction(...args)),
  markAsRead: (...args) => dispatch(markAsReadAction(...args)),
});
NotificationContainer.propTypes = propTypes;
NotificationContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationContainer);



// WEBPACK FOOTER //
// ./src/app/components/app-bar/notification/container.jsx